import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext.jsx';
import VpnGate from './components/VpnGate.jsx';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import AddApp from './pages/AddApp.jsx';
import EditApp from './pages/EditApp.jsx';
import Usage from './pages/Usage.jsx';
import AppViewer from './pages/AppViewer.jsx';
import AnthropicSettings from './pages/AnthropicSettings.jsx';
import AccessManagement from './pages/AccessManagement.jsx';
import DirectorySettings from './pages/DirectorySettings.jsx';
import './index.css';

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-muted">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
   <VpnGate>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/apps/new" element={<Protected><AddApp /></Protected>} />
          <Route path="/apps/:id/edit" element={<Protected><EditApp /></Protected>} />
          <Route path="/apps/:id" element={<Protected><AppViewer /></Protected>} />
          <Route path="/apps/:appId/access" element={<Protected><AccessManagement /></Protected>} />
          <Route path="/usage" element={<Protected><Usage /></Protected>} />
          <Route path="/settings/anthropic" element={<Protected><AnthropicSettings /></Protected>} />
          <Route path="/settings/directory" element={<Protected><DirectorySettings /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
   </VpnGate>
  </React.StrictMode>
);
